import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppConfig } from '../features/config/config.model';

class GlobalElementsState {
    appConfig: AppConfig;
    isDisablingSpinnerVisible: boolean;
    isUsingV2Endpoints: boolean;
}

const globalElementsSlice = createSlice({
    name: 'globalElements',
    initialState: {
        appConfig: null,
        isDisablingSpinnerVisible: false,
        isUsingV2Endpoints: false,
    },
    reducers: {
        setDisablingSpinnerVisible(state: GlobalElementsState, action: PayloadAction<boolean>) {
            state.isDisablingSpinnerVisible = action.payload;
        },
        setAppConfig(state: GlobalElementsState, action: PayloadAction<AppConfig>) {
            state.appConfig = action.payload;
        },
        setIsUsingV2Endpoints(state: GlobalElementsState, action: PayloadAction<boolean>) {
            state.isUsingV2Endpoints = action.payload;
        },
    },
});

export const { setAppConfig, setDisablingSpinnerVisible, setIsUsingV2Endpoints } = globalElementsSlice.actions;
export default globalElementsSlice.reducer;
